/**
 * Add a feedback button to the top-right
 */
angular.module('qkr').directive('feedback', () => {
	return {
            restrict: 'E',
            replace: true,
            scope: true,
        //    Template: '<span class="pull-right feedback">Feedback <i class="fa fa-weixin"></i></span>',
            link(scope, elem, attrs) {
//           	 		Elem.bind('click', function() {
//           	 			Var params = [null, attrs.pagname, null]
//           	 			Utils.modalInstanceFeedback(params)
//           	 		});
            }
        };
});




// WEBPACK FOOTER //
// ./src/directives/feedback.js